import { CONFIG } from '../config';
import initModules from '../initModules';

class BfvSearchLazyload {
  constructor(options = {}) {
    this.$root = options.element;
    this.$spinner = this.$root.querySelector('.js-search-lazyload-spinner');
    this.$contentWrapper = this.$root.querySelector('.js-search-lazyload-content-wrapper');
    this.$dataContainer = this.$root.querySelector('.js-search-lazyload-data-container');
    this.$submitButton = this.$root.querySelector('.js-lazyload-search-submit');

    this.setFilters();
    this.toggleSpinner(false);
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    if (this.$submitButton && !this.$submitButton.hasFilterListener) {
      this.$submitButton.addEventListener('click', (evt) => {
        evt.stopPropagation();
        this.handleFilterSubmit(false, false, true);
      });

      this.$submitButton.hasFilterListener = true;
    }

    if (this.$showAllButton && !this.$showAllButton.hasFilterListener) {
      this.$showAllButton.addEventListener('click', (evt) => {
        evt.stopPropagation();
        this.handleFilterSubmit(true);
      });
      this.$showAllButton.hasFilterListener = true;
    }

    if (this.$showMoreButton && !this.$showMoreButton.hasFilterListener) {
      this.$showMoreButton.addEventListener('click', (evt) => {
        evt.stopPropagation();
        this.handleFilterSubmit(false, true);
      });
      this.$showMoreButton.hasFilterListener = true;
    }

    const $loadOnClickElement = this.$root.closest('.js-lazyload-on-click');
    if (this.$dataContainer && this.$dataContainer.dataset.apiRoute && $loadOnClickElement) {
      $loadOnClickElement.addEventListener('click', this.handleLazyLoadOnClick, true);
    }

    this.$filters.forEach(($filter) => {

      if (!$filter.hasFilterListener) {
        if ($filter.dataset.filterType === 'datepicker') {
          $filter.addEventListener(CONFIG.events.BFV_DATEPICKER_CHANGED, () => {
            const inputWrapper = $filter.querySelector('.input');
            inputWrapper.classList.remove('input--error');
            this.validateRequiredFields(false);
          });
        } else {
          $filter.addEventListener('change', () => {
            if ($filter.dataset.filterType !== 'zipsearch') {
              const inputWrapper = $filter.querySelector('.input');
              if (inputWrapper) {
                inputWrapper.classList.remove('input--error');
              }
            }

            this.validateRequiredFields(false);
          });
        }

        // eslint-disable-next-line
        $filter.hasFilterListener = true;
      }

    });

    window.addEventListener(CONFIG.events.BFV_ZIP_SEARCH_CHANGE, (ev) => {
      if (!!ev.detail && !ev.detail.valid) {
        this.validateRequiredFields(true);
      } else {
        this.validateRequiredFields(false);
      }
    });
  }

  handleLazyLoadOnClick(evt) {
    evt.stopPropagation();
    const $loadOnClickElement = this.$root.closest('.js-lazyload-on-click');
    $loadOnClickElement.classList.remove('js-lazyload-on-click'); // prevent nested FilteredLazyload components from creating another eventListener
    this.loadContentFromApi(this.$dataContainer.dataset.apiRoute);
    $loadOnClickElement.removeEventListener('click', this.handleLazyLoadOnClick, true); // we want to load only once
  }

  setFilters() {
    this.$filters = this.$root.querySelectorAll('.js-lazyload-search-item');
    this.$filterContainer = this.$root.querySelector('.js-lazyload-search-container');
    this.$showAllButton = this.$root.querySelector('.js-lazyload-search-showall');
    this.$showMoreButton = this.$root.querySelector('.js-lazyload-search-showmore');

    this.apiRoute = this.$filterContainer && this.$filterContainer.dataset.apiRoute;
    this.handleLazyLoadOnClick = this.handleLazyLoadOnClick.bind(this);
  }

  /**
   * event handler for when a filter has been submitted
   */
  handleFilterSubmit(showAll, showMore, searchReplace) {
    if (this.validateRequiredFields(true)) {
      this.loadContentFromApi(this.buildApiUrl(showAll, showMore, searchReplace));
    }
  }

  validateRequiredFields(showErrors) {
    let valid = true;

    this.$filters.forEach(($filter) => {
      const input = $filter.getElementsByTagName('input')[0];
      if (input) {
        const inputWrapper = $filter.querySelector('.input');
        if ((input.required && input.value === '') || (input.required && input.value === 'undefined') || inputWrapper.classList.contains('input--error') || (input.name === 'plz' && input.value.length < 5)) {
          valid = false;
          if (inputWrapper && showErrors) {
            inputWrapper.classList.add('input--error');
          }
        }
      }
    });

    this.$submitButton.querySelector('button').disabled = !valid;
    return valid;
  }

  /**
   * iterate through filters and append the selections to the apiRoute as query params
   */
  buildApiUrl(showAll, showMore, searchReplace) {
    const apiUrl = `${this.apiRoute.split('?')[0]}`;
    let params = (this.apiRoute.split('?')[1] || '')
      .split('&')
      .filter((x) => x); // no empty params

    // build api url with all the filter pieces
    this.$filters.forEach(($filter) => {

      switch ($filter.dataset.filterType) {
        case 'datepicker': {
          // append value for a datepicker
          const inputValue = $filter.getElementsByTagName('input')[0].value;

          if ($filter.querySelector('.bfv-datepicker').dataset.type === 'range') {
            // date range type append from and to
            const dateParts = inputValue.split(' bis ');
            const fromDate = dateParts[0] ? dateParts[0] : '';
            const toDate = dateParts[1] ? dateParts[1] : '';

            params.push(`fromDate=${fromDate}`);
            params.push(`toDate=${toDate}`);
          } else {
            // single date type append date
            params.push(`date=${inputValue}`);
          }
        }
          break;

        case 'dropdown': {
          // append value for a dropdown
          const $dropdown = $filter.querySelector('.dropdown select');
          const $selected = $dropdown.options[$dropdown.selectedIndex];

          params.push(`${$filter.dataset.apiTag}=${$selected.value}`);
        }
          break;

        case 'zipsearch': {
          const $zipSearch = $filter.querySelector('input');
          let zipVal = '';
          if ($zipSearch) {
            if ($zipSearch.dataset.zipValue && $zipSearch.dataset.zipValue !== 'undefined') {
              zipVal = $zipSearch.dataset.zipValue;
            } else {
              zipVal = $zipSearch.value;
            }
          }

          params.push(`${$filter.dataset.apiTag}=${zipVal}`);
        }
          break;

        default:
      }
    });

    if (showAll) {
      const showAllParams = this.$showAllButton.dataset.apiTag.split('&');
      showAllParams[0] += '=1';
      params = params.concat(showAllParams);
    }

    if (showMore) {
      params.push(`from=${this.$showMoreButton.dataset.from}`);
      params.push(`size=${this.$showMoreButton.dataset.size}`);
    }

    if (searchReplace) {
      params.push('replace=true');
    }

    return `${apiUrl}?${params.join('&')}`;
  }

  /**
   * call api and insert response into root
   * @param apiUrl
   */
  loadContentFromApi(apiUrl) {
    this.$contentWrapper.innerHTML = '';
    this.toggleSpinner(true);
    this.checkIfContentIsAvailable(true);

    const $dataContainer = this.$root.querySelector('.js-search-lazyload-data-container');

    window.divae.restApi
      .loadData(apiUrl, 'application/xhtml+xml')
      .then((_response) => {
        const replacesContent = _response.includes('js-search-lazyload-replace');

        // replace content (no button available)
        if (replacesContent && $dataContainer) {
          $dataContainer.innerHTML = _response;
          initModules({ rootElement: $dataContainer });

          // add to bottom (load more button)
        } else if (!replacesContent) {
          const $resultsContainers = $dataContainer.querySelectorAll('.js-search-lazyload-content-wrapper');
          const $resultsContainer = $resultsContainers[$resultsContainers.length - 1];

          const $wrapper = document.createElement('div');
          $wrapper.classList.add('js-search-lazyload-content-wrapper', 'bfv-search-lazyload__load-more-wrapper');
          $wrapper.innerHTML = _response;

          $resultsContainer.replaceChild($wrapper, $resultsContainer.querySelector('.js-lazyload-search-showmore'));
          initModules({ rootElement: $resultsContainer });
        } else {
          $dataContainer.innerHTML = _response;
          initModules({ rootElement: $dataContainer });
        }

        this.toggleSpinner(false);
        this.checkIfContentIsAvailable(false);
        this.setFilters();
        this.bindEvents();
      });
  }

  /**
   * toggle visibility of a spinner based on param
   * @param show
   */
  toggleSpinner(show) {
    if (this.$spinner) {
      this.$spinner.style.display = show ? 'block' : 'none';
    }
  }

  hideButton() {
    if (this.$showAllButton) {
      this.$showAllButton.style.display = 'none';
    } else if (this.$showMoreButton) {
      this.$showMoreButton.style.display = 'none';
    }
  }

  showButton() {
    if (this.$showAllButton) {
      this.$showAllButton.style.display = 'block';
    } else if (this.$showMoreButton) {
      this.$showMoreButton.style.display = 'block';
    }
  }

  checkIfContentIsAvailable(show) {
    if (show) {
      this.hideButton();
    } else {
      this.showButton();
    }
  }
}

export default BfvSearchLazyload;
